export const baseLineHeights = {
  none: '100%',
  tightest: '115%',
  tighter: '125%',
  tight: '135%',
  normal: '145%',
  loose: '200%',
};

export const lineHeights = {
  ...baseLineHeights,
  body: baseLineHeights.normal,
  heading: baseLineHeights.tightest,
};
